<template>
  <div style="padding-top: 130px;user-select: none">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-position="left"
             class="login-container">
      <div class="top">
        <img src="../assets/img/logo.png" alt="icon" width="100" height="100">
      </div>
      <el-form-item prop="userName">
        <el-input v-model="ruleForm.userName" auto-complete="off" placeholder="姓名" autofocus="true"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input v-model="ruleForm.phone" auto-complete="off" placeholder="登录的电话号码" autofocus="true"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="输入密码"></el-input>
      </el-form-item>
      <el-form-item prop="passwordTwo">
        <el-input type="password" v-model="ruleForm.passwordTwo" auto-complete="off" placeholder="确认密码"></el-input>
      </el-form-item>
      <el-form-item >
        <el-col :span="11">
          <el-form-item prop="code">
            <el-input type="input" v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="2">&nbsp;</el-col>
        <el-col :span="11">
          <el-button type="primary" :disabled="isAnable" plain @click="sendCode">{{msg}}</el-button>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" style="width:100%;" @click.prevent="register('ruleForm')" >注册
        </el-button>
      </el-form-item>
      <div class="footer-links">
        <router-link to="/"><span style="float: right"><i class="el-icon-sort"></i> 返回首页</span></router-link>
        <router-link to="/login"><i class="el-icon-edit-outline"></i> 登录</router-link>
      </div>
      <div class="drag" v-if="isShow">
        <drag-verify :width="250" @passcallback="callback" background="#e8e8e8" success-icon="fa fa-check" handler-icon="fa fa-angle-double-right" :height="30" textSize="12px" :circle="false" text="请滑动到最右侧"></drag-verify>
      </div>
    </el-form>
  </div>
</template>

<script>
import {Message} from 'element-ui'
import {sendCode, register} from '../api/login'
import dragVerify from 'vue-drag-verify'
import 'font-awesome/css/font-awesome.min.css'
export default {
  name: 'login',
  components: {
    dragVerify
  },
  data () {
    var validatePassword = (rule, value, callback) => {
      if (this.wei.isNull(value)) {
        return callback(new Error('密码不能为空'))
      } else if (this.ruleForm.password !== value) {
        return callback(new Error('两次密码输入不一样'))
      }
      callback()
    }
    return {
      msg: '发送验证码',
      isAnable: false,
      ruleForm: {
        userName: '',
        password: '',
        passwordTwo: '',
        phone: '',
        code: ''
      },
      rules: {
        userName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '电话格式不正确', trigger: ['blur']},
          { required: true, message: '电话号码不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        passwordTwo: [
          {validator: validatePassword, required: true, trigger: 'blur'}
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      loading: false,
      isShow: false,
      number: 60
    }
  },
  created () {
  },
  methods: {
    register (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.loading = true
          register(this.ruleForm).then((response) => {
            Message({
              message: response.data.msg,
              type: 'success',
              duration: 5 * 1000
            })
            if (response.data.status === 0) {
              _this.$router.push('/login')
            }
          }).catch(() => {
            setTimeout(() => {
              _this.loading = false
            }, 1000)
          })
        }
      })
    },
    sendCode () {
      this.$refs.ruleForm.validateField('phone', (valid) => {
        if (this.wei.isNull(valid)) {
          this.isShow = true
          this.number = 60
        }
      })
    },
    callback () {
      this.time = null
      this.isAnable = true
      this.msg = `重新发送${this.number}s`
      sendCode('weiwi', this.ruleForm.phone).then((response) => {
        Message({
          message: response.data.msg,
          type: 'success',
          duration: 5 * 1000
        })
        this.time = setInterval(() => {
          if (this.number === 0) {
            this.isAnable = false
            this.isShow = false
            this.msg = '发送验证码'
            clearTimeout(this.time)
            return
          }
          this.msg = `重新发送${this.number--}s`
        }, 1000)
      }).catch(() => {
        this.isAnable = false
        this.isShow = false
        this.number = 60
        this.msg = '发送验证码'
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .top
    text-align: center
    padding: 0px 0 20px
  .login-container
    border-radius: 5px
    background-clip: padding-box
    margin: auto
    width: 320px
    padding: 35px 35px 15px 35px
    background: #fff
    border: 1px solid #ddd
    .imgCode
      width 100%
      height 40px
    .remember
      margin: 0px 0px 20px 0px
    .footer-links
      a
        color: #b9b9b9
        font-size: 13px
        text-decoration none
        &:hover
          color #1a191f
    .drag
      position absolute
      bottom 270px
      background: #66cc66;
      padding: 2px;
    .drag_verify
      .dv_progress_bar
        transition none !important
</style>
